<template>
    <div class="pb-3 max-mob:pb-1.5">
        <CustomDataTable
            v-model:page="page"
            v-model:selected="selected"
            :headerType="SETTINGS_HEADER_TABLE.tcpaShield"
            :items="tcpaShieldStore.items"
            :loading="tcpaShieldStore.loading"
            :total="tcpaShieldStore.total"
            showSelect
            @editAction="goToDetail"
        >
            <template #item.campaigns="{ item }">
                <CampaignsViewList
                    v-if="item.campaigns.length"
                    class="-ml-2.5"
                    :items="item.campaigns"
                    @onOpenDialog="onOpenCampaignsDialog(item)"
                />

                <div v-else>-//-</div>
            </template>

            <template #item.type="{ item }">
                <div class="max-w-inherit truncate">
                    {{ item.type.name }}
                </div>
            </template>

            <template #item.status="{ item }">
                <StatusAction
                    :item="item"
                    :loading="tcpaShieldStore.statusLoading"
                    :disabled="!editTcpaShieldPermission"
                    @changeStatus="tcpaShieldStore.goToUpdateStatus(item)"
                    @click.stop
                />
            </template>

            <template #item.actions="{ item }">
                <div class="flex items-center justify-center gap-x-1.5">
                    <DetailAction
                        class="text-gray-200 hover:text-purple transition-colors cursor-pointer"
                        :edit="editTcpaShieldPermission"
                        @click.stop="goToDetail(item)"
                    />

                    <DeleteIcon
                        v-if="deleteTcpaShieldPermission"
                        class="text-gray-200 hover:text-purple transition-colors cursor-pointer"
                        v-tippy="getTippyTable('Delete')"
                        @click.stop="onOpenDeleteDialog(item)"
                    />
                </div>
            </template>

            <template #dialogs>
                <ConfirmDialog
                    v-model="showConfirmDialog"
                    :loading="tcpaShieldStore.actionLoading"
                    :item="selectedItem"
                    :title="titleDialog"
                    :subTitle="subTitleDialog"
                    :confirmButtons="['Cancel', 'Confirm']"
                    @submitForm="deleteTcpaShield"
                />

                <ViewCampaignsDialog
                    v-model="showCampaignsDialog"
                    :items="selectedItem.campaigns"
                />
            </template>
        </CustomDataTable>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import CustomDataTable from '@/components/table/CustomDataTable.vue'
import DetailAction from '@/components/actions/DetailAction.vue'
import DeleteIcon from '@/components/icons/DeleteIcon.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import CampaignsViewList from '@/components/lists/Campaigns/CampaignsViewList.vue'
import ViewCampaignsDialog from '@/components/dialogs/ViewCampaignsDialog.vue'
import StatusAction from '@/components/actions/StatusAction.vue'

import { getTippyTable } from '@/helpers/tippy-helper'

import { useTcpaShieldStore } from '@/store/call-tracking/suppressionList/tcpaShieldStore'
import { usePermissionsStore } from '@/store/permissionsStore'

import { ROUTES } from '@/constants/routes'
import { SETTINGS_HEADER_TABLE } from '@/constants/headersTable/settingsHeaderTable'

const tcpaShieldStore = useTcpaShieldStore()
const permissionsStore = usePermissionsStore()

const router = useRouter()
const route = useRoute()

const showCampaignsDialog = ref(false)
const showConfirmDialog = ref(false)

const selectedItem = ref({})
const titleDialog = ref('')
const subTitleDialog = ref('')
const propDialog = ref('')

const editTcpaShieldPermission = computed(() => permissionsStore.permissions.tcpaShield.edit)
const deleteTcpaShieldPermission = computed(() => permissionsStore.permissions.tcpaShield.delete)

const page = computed({
    get() {
        return tcpaShieldStore.page
    },
    set(newPage) {
        tcpaShieldStore.changePage(newPage)
    },
})

const selected = computed({
    get() {
        return tcpaShieldStore.selected
    },
    set(newSelectedItems) {
        tcpaShieldStore.changeSelectedItems(newSelectedItems)
    },
})

function goToDetail({ slug }) {
    router.push({ name: ROUTES.detailTcpaShield, params: { workspace: route.params.workspace, slug } })
}

function onOpenCampaignsDialog(item) {
    showCampaignsDialog.value = true

    selectedItem.value = item
}

function onOpenDeleteDialog(item) {
    showConfirmDialog.value = true

    selectedItem.value = item
    propDialog.value = 'name'
    titleDialog.value = 'Delete TCPA Shield'
    subTitleDialog.value = 'Are you sure you want to delete this Shield?'
}

async function deleteTcpaShield(item) {
    const success = await tcpaShieldStore.goToDeleteTcpaShield([item.slug])

    if (success) {
        showConfirmDialog.value = false
    }
}
</script>
